import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import {
  createMarketingSlice,
  createPaymentSlice,
  createScanSlice,
  createUIStateSlice,
  createUserSlice,
  MarketingSlice,
  PaymentSlice,
  ScanSlice,
  UIStateSlice,
  UserSlice,
} from '.';

type PrenuvoStore = MarketingSlice & PaymentSlice & ScanSlice & UIStateSlice & UserSlice;

export const usePrenuvoStore = create<PrenuvoStore>()(
  devtools(
    (...slice) => ({
      ...createScanSlice(...slice),
      ...createUserSlice(...slice),
      ...createPaymentSlice(...slice),
      ...createUIStateSlice(...slice),
      ...createMarketingSlice(...slice),
    }),
    { name: 'PrenuvoStore' },
  ),
);
